export default {"src":"/frontend-static/_next/static/media/ic_leaf.2c8ef65f.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};